const queryKeys = {
  USER_SCHEMAS: 'userSchemas',
  ALL_USERS: 'allUsers',
  SCHEMA_SUGGESTIONS: 'schemaSuggestions',
};

export default queryKeys;
